<img [src]="contest.bannerUrl" class="w-full rounded-md">
